import { useQuery } from '@tanstack/react-query';
import { brokerOfferApiService } from '../services/brokerOfferApi';
import type { BrokerOfferDetails } from '../types/brokerOffer';

export const BrokerOfferQueryKeys = {
  offer: (offerId: string) => ['broker-offer', offerId] as const,
};

interface UseBrokerOfferReturn {
  offer: BrokerOfferDetails | undefined;
  isLoading: boolean;
  error: Error | null;
}

export function useBrokerOffer(offerId: string | undefined): UseBrokerOfferReturn {
  const offerQuery = useQuery({
    queryKey: BrokerOfferQueryKeys.offer(offerId ?? ''),
    queryFn: () => brokerOfferApiService.getOffer(offerId as string),
    enabled: !!offerId,
  });

  return {
    offer: offerQuery.data,
    isLoading: offerQuery.isLoading,
    error: offerQuery.error,
  };
}
